export enum ModelMode {
  "Train" = "Train",
  "Test" = "Test",
}
